/**
 * Replaces the params(e.g., /:id) of a route with the specified value.
 *
 * @param {String} route - constant of a route
 * @param {String|Number|Array} param - a value the param should be replaced with. Can be just a string for just a single replace or array for multiple
 */

import { useNavigate } from "react-router";
import { routes } from "../configs/constants/routes";

export const formatRoute = (route: string, params: any[] = []) => {
	if (typeof params === "string" || typeof params === "number")
		return route.replace(/:\w+/, params);

	return route
		.split("/")
		.map((route) => {
			if (!route.includes(":")) return route;
			return route.replace(/:\w+/, params.shift());
		})
		.join("/");
};

/**
 * Check router strings for hide left navigation menu because some views don't require left navigation. ex: salary-journal
 *
 * @param {String} route - constant of a route
 */

export const checkNavigationMenuVisibility = (route: string) => {
	const checkHideVisibilityStrings = ["salary-journal"];

	return !!checkHideVisibilityStrings.find((v) => route.includes(v));
};

// Shortcuts for navigation

export function jobRoute(jobId: string) {
	return formatRoute([routes.JOB_DETAILS, routes.JOB_OVERVIEW].join("/"), [jobId]);
}

export function documentEditRoute(documentId: string) {
	return formatRoute([routes.DOCUMENT_EDIT].join("/"), [documentId]);
}

export function documentLinkEditRoute(documentId: string) {
	return formatRoute([routes.DOCUMENT_EDIT_LINK].join("/"), [documentId]);
}

export function customerRoute(customerId: string) {
	return formatRoute([routes.CUSTOMER_DETAILS, routes.CUSTOMER_PROFILE].join("/"), [customerId]);
}

export function userRoute(customerId: string, userId: string) {
	return formatRoute([routes.CUSTOMER_USER_EDIT].join("/"), [customerId, userId]);
}

export function navigateToCustomerUsers(
	navigate: ReturnType<typeof useNavigate>,
	customerId: string
) {
	navigate(formatRoute([routes.CUSTOMER_DETAILS, routes.CUSTOMER_USERS].join("/"), [customerId]));
}

export function navigateToCustomerUser(
	navigate: ReturnType<typeof useNavigate>,
	customerId: string,
	userId: string
) {
	navigate(formatRoute([routes.CUSTOMER_USER_EDIT].join(""), [customerId, userId]));
}

export function navigateToCreateCustomerUser(
	navigate: ReturnType<typeof useNavigate>,
	customerId: string
) {
	navigate(formatRoute([routes.CUSTOMER_USER_CREATE].join("/"), [customerId]));
}

export function consultantRoute(consultantId: string) {
	return formatRoute([routes.CONSULTANTS_DETAILS, routes.CONSULTANTS_PROFILE].join("/"), [
		consultantId,
	]);
}

export function navigateToCreateConsultant(navigate: ReturnType<typeof useNavigate>) {
	navigate(routes.CONSULTANTS_NEW);
}

export function navigateToCreateJob(navigate: ReturnType<typeof useNavigate>) {
	navigate(routes.JOB_CREATE);
}

export function navigateToCreateCustomer(navigate: ReturnType<typeof useNavigate>) {
	navigate(routes.CUSTOMER_CREATE);
}

export function navigateToCreateCandidate(navigate: ReturnType<typeof useNavigate>) {
	navigate(routes.RECRUITMENT_CREATE);
}
